import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=715d4841&scoped=true&"
import script from "./SsoCallback.vue?vue&type=script&lang=js&"
export * from "./SsoCallback.vue?vue&type=script&lang=js&"
import style0 from "./SsoCallback.vue?vue&type=style&index=0&id=715d4841&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d4841",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
